import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {updateNews} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import NewsForm from './NewsForm';
import PropTypes from 'prop-types';
import {toast} from "react-toastify";

class NewsEditButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      updating: false,
      errors: {}
    }

    this.newsForm = React.createRef();
  }

  newsUpdate(e, data) {
    e.preventDefault();
    this.setState({updating: true});

    this.props.updateNews({
      data: data.news,
      id: this.props.news.id
    }).then(() => {
      this.props.handleChange();
      toast.success(<FormattedMessage id="admin.newsEditButton.toast.success" />);
      this.setState({
        updating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        updating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { updating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="xl">
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="admin.newsEditButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <NewsForm errors={errors} onSubmit={this.newsUpdate} ref={this.newsForm} news={this.props.news}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={updating}
            data-style={ZOOM_OUT}
            onClick={e => this.newsUpdate(e, this.newsForm.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" size="sm" onClick={() => this.toggleModal()}><i className="fas fa-edit" /> <FormattedMessage id="_.button.edit"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

NewsEditButton.propTypes = {
  news: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, { updateNews }, null, {forwardRef: true})(NewsEditButton);